import { InvalidSection, InvalidSectionsItem } from '@features/campaigns/shared/types/campaign';

export function getInvalidSectionNames(items: InvalidSectionsItem[] | undefined): InvalidSection[] {
  return items?.map((item) => item.section) ?? [];
}
